// src/components/PageBreak.js
import { Node, mergeAttributes, nodeInputRule } from '@tiptap/core';

export const PageBreak = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,
  defining: true,
  isolating: true,

  parseHTML() {
    return [{ tag: 'div[data-type="page-break"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ 'data-type': 'page-break', contenteditable: 'false' }, HTMLAttributes),
    ];
  },

  addCommands() {
    return {
      insertPageBreak:
        () =>
        ({ chain, state }) => {
          return chain()
            .command(({ tr }) => {
              const { $from } = state.selection;
              if ($from.parent.content.size) tr.split($from.pos);
              return true;
            })
            .insertContent([{ type: this.name }, { type: 'paragraph' }])
            .run();
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => this.editor.commands.insertPageBreak(),
    };
  },

  addInputRules() {
    return [
      nodeInputRule({
        find: /^---page---\s*$/,
        type: this.type,
      }),
    ];
  },
});

export default PageBreak; // optional default export so either import style works
